module.exports = __webpack_public_path__ + "img/lsr1011jp01.d342927a.jpg";